import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import './BillBody.css';
import { FaIndianRupeeSign } from "react-icons/fa6";
import { ToastContainer, toast } from "react-toastify";

export default function BillBody() {
  const [customerDetails, setCustomerDetails] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showConfirmStatus, setShowConfirmStatus] = useState(false); // State for status change confirmation
  const [showConfirmCancel, setShowConfirmCancel] = useState(false); // State for cancel confirmation
  const location = useLocation();
  const navigate = useNavigate();
  const { orderDate, customerPhone } = location.state || {};

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const fetchCustomerDetails = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/custDetails?customerPhone=${encodeURIComponent(customerPhone)}`);
        if (!response.ok) {
          throw new Error('Failed to fetch customer details');
        }
        const data = await response.json();
        setCustomerDetails(data);
      } catch (error) {
        setError(error.message);
      }
    };

    const fetchOrderDetails = async () => {
      try {
        const formattedOrderDate = formatDate(orderDate);
        const response = await fetch(`${process.env.REACT_APP_API_URL}/Details?orderDate=${formattedOrderDate}&customerPhone=${encodeURIComponent(customerPhone)}`);
        if (!response.ok) {
          throw new Error('Failed to fetch order details');
        }
        const data = await response.json();
        setProducts(data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    if (customerPhone && orderDate) {
      fetchCustomerDetails();
      fetchOrderDetails();
    }
  }, [orderDate, customerPhone]);

  const handleChangeStatus = async () => {
    try {
      const formattedOrderDate = formatDate(orderDate);
      const response = await fetch(`${process.env.REACT_APP_API_URL}/statusChange?orderDate=${formattedOrderDate}&customerPhone=${encodeURIComponent(customerPhone)}`);
      if (!response.ok) {
        throw new Error('Failed to change status');
      }
      toast.success("Status changed successfully!", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setTimeout(() => navigate("/adminPage"), 1000);
    } catch (error) {
      setError(error.message);
    }
  };

  const handleCancelOrder = async () => {
    try {
      const formattedOrderDate = formatDate(orderDate);
      const response = await fetch(`${process.env.REACT_APP_API_URL}/cancelOrder?orderDate=${formattedOrderDate}&customerPhone=${encodeURIComponent(customerPhone)}`, {
        method: 'PATCH', // Use PATCH or appropriate method for your API
      });
      if (!response.ok) {
        throw new Error('Failed to cancel order');
      }
      toast.success("Order canceled successfully!", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setTimeout(() => navigate("/adminPage"), 1000);
    } catch (error) {
      setError(error.message);
    }
  };

  const handleConfirmStatus = () => {
    setShowConfirmStatus(false);
    handleChangeStatus();
  };

  const handleConfirmCancel = () => {
    setShowConfirmCancel(false);
    handleCancelOrder();
  };

  const handleCancel = (type) => {
    if (type === 'status') {
      setShowConfirmStatus(false);
    } else {
      setShowConfirmCancel(false);
    }
  };

  const printBill = () => {
    // Create a new iframe element to hold the printable content
    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    document.body.appendChild(iframe);
  
    const iframeDocument = iframe.contentWindow.document;
  
    // Set the printable content in the iframe document
    iframeDocument.open();
    iframeDocument.write(`
      <html>
        <head>
          <title>Invoice</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              padding: 20px;
            }
            .container {
              width: 100%;
              max-width: 800px;
              margin: 0 auto;
            }
            .card {
              border: 1px solid #ddd;
              padding: 20px;
              background-color: #f9f9f9;
              border-radius: 8px;
            }
            .logo-container {
              text-align: center;
            }
            .logo {
              width: 100px;
            }
            .text-center {
              text-align: center;
            }
            .table-container {
              width: 100%;
              margin-top: 20px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 10px;
            }
            table, th, td {
              border: 1px solid black;
            }
            th, td {
              padding: 8px;
              text-align: left;
            }
            .summary {
              margin-top: 20px;
            }
            .totals p {
              font-size: 18px;
            }
            .footer {
              margin-top: 20px;
              text-align: center;
              font-size: 16px;
            }
          </style>
        </head>
        <body>
          <div class="container">
            <div id="printableCard" class="card">
              <div class="card-body">
                <div class="header"></div>
                <div class="logo-container">
                  <img src="/thedata/LogoTDRS.png" alt="Logo" class="logo" />
                  <p class="logo-text display-6">The Dry Fruit Shop</p>
                </div>
                <div class="text-center mt-2"><strong>Y.R Traders - GSTIN:</strong> 01EQWPB9010F1Z3</div>
                <div class="text-center mb-2"><strong>M.Y Bhat & Sons - FSSAI:</strong> 11022430000432</div>
                <div class="details">
                  <div class="customer-info">
                    <ul>
                      <li><strong>To:</strong> ${Name}</li>
                      <li><strong>Address: </strong>${Address}, ${City}, ${State}, ${Country}</li>
                      <li><strong>Phone: </strong>${Phone}</li>
                    </ul>
                  </div>
                  <div class="invoice-details">
                    <ul>
                      <li><strong>Pin Code: </strong>${Pin}</li>
                      <li><strong>Order Date:</strong> ${new Date(orderDate).toLocaleDateString()}</li>
                      <li><strong>Status:</strong> Order Confirmed</li>
                    </ul>
                  </div>
                </div>
                <div class="table-container">
                  <table>
                    <thead>
                      <tr>
                        <th>OrderId</th>
                        <th>Product Name</th>
                        <th>Product Weight</th>
                        <th>Qty</th>
                        <th>Unit Price</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      ${products
                        .map(
                          (product) => `
                          <tr>
                            <td>${product.OrderId}</td>
                            <td>${product.ProductName}</td>
                            <td>${product.ProductWeight}</td>
                            <td>${product.ProductQuantity}</td>
                            <td>${product.ProductPrice}</td>
                            <td>${(product.ProductPrice * product.ProductQuantity).toFixed(2)}</td>
                          </tr>`
                        )
                        .join('')}
                    </tbody>
                  </table>
                </div>
                <div class="summary">
                  <div class="notes">
                    <p>The total amount shown already includes GST, shipping, and packaging. What you see is what you pay.</p>
                  </div>
                  <div class="totals">
                
                  
                    <p><strong>Total Amount:</strong> ₹${totalAmount}</p>
                  </div>
                </div>
                <div class="footer">
                  <p>Thank you for your purchase</p>
                </div>
              </div>
            </div>
          </div>
        </body>
      </html>
    `);
    iframeDocument.close();
  
    // Wait for the iframe content to load, then print
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
  
    // Optionally, remove the iframe after printing (clean up)
    iframe.remove();
  };
  
  

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;
  if (!customerDetails || products.length === 0) return <p>No data available.</p>;

  const {
    Name,
    Phone,
    Country,
    State,
    City,
    Address,
    Pin,
  } = customerDetails;

  const calculateTotal = (products) => {
    return products.reduce(
      (total, product) => total + product.ProductPrice * product.ProductQuantity,
      0
    ).toFixed(2);
  };

  const subtotal = calculateTotal(products);
 
  const totalAmount = (parseFloat(subtotal) ).toFixed(2);

  return (
    <div className="container">
      <div id="printableCard" className="card"> {/* This is the part that will be printed */}
        <div className="card-body">
          <div className="header"></div>
          <div className="logo-container">
            <img src="/thedata/LogoTDRS.png" alt="Logo" className="logo" />
            <p className="logo-text display-6">The Dry Fruit Shop</p>
          </div>
          <div className="text-center mt-2"><strong>Y.R Traders - GSTIN:</strong> 01EQWPB9010F1Z3</div>
          <div className="text-center mb-2"><strong>M.Y Bhat & Sons - FSSAI:</strong> 11022430000432</div>
          <div className="details">
            <div className="customer-info">
              <ul>
                <li><strong>To:</strong> {Name}</li>
                <li><strong>Address: </strong>{Address}, {City}, {State}, {Country}</li>
                <li><strong>Phone: </strong>{Phone}</li>
              </ul>
            </div>
            <div className="invoice-details">
              <ul>
                <li><strong>Pin Code: </strong>{Pin}</li>
                <li><strong>Order Date:</strong> {new Date(orderDate).toLocaleDateString()}</li>
                <li><strong>Status:</strong> Order Confirmed</li>
              </ul>
            </div>
          </div>
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>OrderId</th>
                  <th>Product Name</th>
                  <th>Product Weight</th>
                  <th>Qty</th>
                  <th>Unit Price</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {products.map((product) => (
                  <tr key={product.OrderId}>
                    <td>{product.OrderId}</td>
                    <td>{product.ProductName}</td>
                    <td>{product.ProductWeight}</td>
                    <td>{product.ProductQuantity}</td>
                    <td>{product.ProductPrice}</td>
                    <td>{(product.ProductPrice * product.ProductQuantity).toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="summary">
            <div className="notes">
              <p>The total amount shown already includes GST, shipping, and packaging. What you see is what you pay.</p>
            </div>
            <div className="totals">
             
             
              <p><strong>Total Amount:</strong> <FaIndianRupeeSign />{totalAmount}</p>
            </div>
          </div>
          <div className="footer">
            <p>Thank you for your purchase</p>
          </div>
        </div>
      </div>

      {/* Confirmation dialog for Change Status */}
      {showConfirmStatus && (
        <div className="confirmation-dialog mt-4">
          <p className="text-center h5">
            Are you sure you want to change the status to Complete? This action cannot be undone.
          </p>
          <div className="d-flex justify-content-center">
            <button className="btn btn-danger mr-2 rounded-pill px-5 py-3 shadow" onClick={handleConfirmStatus}>
              Yes, Change Status
            </button>
            <button className="btn btn-secondary rounded-pill px-5 py-3 shadow" onClick={() => handleCancel('status')}>
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* Confirmation dialog for Cancel Order */}
      {showConfirmCancel && (
        <div className="confirmation-dialog mt-4">
          <p className="text-center h5">
            Are you sure you want to cancel the order? This action cannot be undone.
          </p>
          <div className="d-flex justify-content-center">
            <button className="btn btn-danger mr-2 rounded-pill px-5 py-3 shadow" onClick={handleConfirmCancel}>
              Yes, Cancel Order
            </button>
            <button className="btn btn-secondary rounded-pill px-5 py-3 shadow" onClick={() => handleCancel('cancel')}>
              Cancel
            </button>
          </div>
        </div>
      )}

        {/* Print button */}
        <div className="print-button-container">
        <button className="btn-lg btn-primary shadow rounded-pill mt-5" onClick={printBill}>
          Print Bill
        </button>
      </div>

      {/* Change Status button */}
      <div className="change-status-container">
        <button className="btn-lg btn-success shadow rounded-pill mt-5" onClick={() => setShowConfirmStatus(true)}>
          Change Status to Complete
        </button>
      </div>

      {/* Cancel Order button */}
      <div className="cancel-order-container">
        <button className="btn-lg btn-danger shadow rounded-pill mt-5" onClick={() => setShowConfirmCancel(true)}>
          Cancel Order
        </button>
      </div>

    

      <ToastContainer />
    </div>
  );
}
